(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');

    // On mobile, show the promise strip after the product grid; elsewhere, under the header.
    const placePromises = () => {
      document.querySelectorAll('[data-collection-promises]').forEach((strip) => {
        const home = document.querySelector(`[data-promises-home="${strip.dataset.collectionPromises}"]`);
        if (!home) return;
        const heroSection = home.closest('.shopify-section');
        const gridSection = heroSection?.nextElementSibling;

        if (mobile.matches && gridSection) {
          if (strip.previousElementSibling !== gridSection) gridSection.after(strip);
        } else if (home.nextElementSibling !== strip) {
          home.after(strip);
        }
        strip.classList.add('is-placed');
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placePromises);
    } else {
      placePromises();
    }
    mobile.addEventListener('change', placePromises);
    document.addEventListener('shopify:section:load', placePromises);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
